/* ===========================================================================
   ROVE NEXT -- PDP GALLERY: SHOW A PHOTO WHOLE WHEN IT IS NOT THE FRAME'S SHAPE.
   16 October 2026.

   The buy box's main frame is a fixed 5:4 and every photo was drawn into it
   with object-fit:cover. The studio shots are 5:4, so they fit exactly, but the
   lifestyle images are 3:2 (17% of the width cut away) and the portrait ones
   (diane12, 04, reya6) lost 47% of their height -- Stevie: "the images are
   being cut off".

   Changing the frame's shape per photo would make the gallery jump in height
   on every slide, so instead: when the shown photo's shape differs from the
   studio shots' 5:4 by more than 6%, it is drawn WHOLE (object-fit:contain) and the space
   around it is filled with a soft, blurred copy of the same photo -- no
   cropping and no empty bars. A photo that matches the frame (every studio
   shot) is untouched, and so are videos.

   It only watches the main frame's <img>, so it follows every way the photo
   changes (arrows, thumbnails, swipes, colour, configuration) without touching
   the gallery's own code. Thumbnails keep their crop; the zoom view already
   shows photos whole.
   =========================================================================== */
(function () {
  if (window.__rnGalleryFit) return;
  window.__rnGalleryFit = true;

  var FRAME = '[id^="rn-bb-"] .bb-main';
  var TOLERANCE = 0.06;
  /* Compared with the STUDIO shape, not the frame's current shape: on phones the frame is
     not 5:4, and studio shots there must keep their usual crop rather than gain a blur. */
  var STUDIO = 5 / 4;

  (function style() {
    try {
      var s = document.createElement('style');
      s.textContent =
        /* The photo itself is left un-positioned, exactly as without this file, so every control in
           the frame (badge, 360, dots, arrows, sound button) still paints above it. The blurred
           fill sits behind it: z-index -1 inside the frame, which isolation keeps from escaping. */
        FRAME + '.rn-fit{isolation:isolate}' +
        FRAME + '.rn-fit::before{content:"";position:absolute;inset:-30px;z-index:-1;pointer-events:none;' +
        'background:var(--rn-fit-bg) center/cover no-repeat;filter:blur(24px) brightness(.9) saturate(1.05)}' +
        FRAME + '.rn-fit > img{object-fit:contain !important}';
      document.head.appendChild(s);
    } catch (e) {}
  })();

  function check(main) {
    var im = main.querySelector(':scope > img');
    if (!im) { main.classList.remove('rn-fit'); return; }
    var apply = function () {
      if (main.querySelector(':scope > img') !== im) return;
      if (!im.naturalWidth || !im.naturalHeight) return;
      var mismatch = (im.naturalWidth / im.naturalHeight) / STUDIO;
      if (Math.abs(mismatch - 1) > TOLERANCE) {
        main.style.setProperty('--rn-fit-bg', 'url("' + (im.currentSrc || im.src) + '")');
        main.classList.add('rn-fit');
      } else {
        main.classList.remove('rn-fit');
      }
    };
    if (im.complete && im.naturalWidth) apply();
    else { main.classList.remove('rn-fit'); im.addEventListener('load', apply, { once: true }); }
  }

  function watch(main) {
    if (main.__rnFit) return;
    main.__rnFit = true;
    check(main);
    if ('MutationObserver' in window) {
      new MutationObserver(function () { check(main); })
        .observe(main, { childList: true, subtree: true, attributes: true, attributeFilter: ['src'] });
    }
  }

  function run() { Array.prototype.forEach.call(document.querySelectorAll(FRAME), watch); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  document.addEventListener('shopify:section:load', run);
  window.addEventListener('resize', function () { Array.prototype.forEach.call(document.querySelectorAll(FRAME), check); });
})();
